import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
    apiKey: "AIzaSyDPkGLMJCHi0qJE1sk7oODp_34Bpk-5t88",
    authDomain: "chandini-project.firebaseapp.com",
    databaseURL: "https://chandini-project-default-rtdb.firebaseio.com", // Add this line (copy from Firebase console)
    projectId: "chandini-project",
    storageBucket: "chandini-project.firebasestorage.app",
    messagingSenderId: "1050393382437",
    appId: "1:1050393382437:web:ce344d848b6ccab3ebf9cc",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
